import { render, staticRenderFns } from "./AdminTicketsCancel.vue?vue&type=template&id=95e6b97e&scoped=true&"
import script from "./AdminTicketsCancel.vue?vue&type=script&lang=js&"
export * from "./AdminTicketsCancel.vue?vue&type=script&lang=js&"
import style0 from "./AdminTicketsCancel.vue?vue&type=style&index=0&id=95e6b97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e6b97e",
  null
  
)

export default component.exports